import type { CityConfig } from "../city-template/types";

export const altonConfig: CityConfig = {
  city: "Alton",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "alton",
  route: "/cities/alton",
  title: "Emergency Passport Alton IL | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Alton, Illinois — as fast as 24 hours. Fast passport renewal for Lewis and Clark Community College students, Great River Road travelers, and all Madison County residents. A+ BBB rated registered State Dept. courier serving the River Bend region.",
  h1: "Emergency & Expedited Passport Services in Alton, IL",
  heroSubtitle: "European river cruise departing in 5 days and your passport's damaged? Corporate trip to Germany and forgot to renew? Living on the Mississippi doesn't help when you need a passport overnight. We help Alton residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Madison County and the entire River Bend.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Alton%20Illinois%20historic%20Mississippi%20River%20town%20with%20scenic%20riverfront%20bluffs%20and%20limestone%20cliffs%2C%20charming%20brick%20buildings%20along%20Broadway%20in%20the%20historic%20downtown%20district%2C%20the%20Clark%20Bridge%20spanning%20the%20Mississippi%20River%20at%20golden%20hour%2C%20riverboat%20on%20the%20water%2C%20autumn%20foliage%20along%20the%20riverbank%2C%20professional%20landscape%20photography%2C%20classic%20Midwest%20river%20town%20atmosphere%20with%20dramatic%20limestone%20bluffs%20backdrop&width=1800&height=700&seq=alton-hero-001&orientation=landscape",
  heroImageAlt: "Alton Illinois Mississippi River town with Clark Bridge and limestone bluffs at golden hour",
  geoPosition: "38.8906;-90.1843",
  geoPlacename: "Alton, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
    distance: "Approximately 4 hours 30 minutes northeast of Alton via I-55",
  },
  nearbyCitiesZips: [
    { name: "Alton", zips: "62002" },
    { name: "Godfrey", zips: "62035" },
    { name: "East Alton", zips: "62024" },
    { name: "Wood River", zips: "62095" },
    { name: "Bethalto", zips: "62010" },
    { name: "Roxana", zips: "62084" },
    { name: "Edwardsville", zips: "62025, 62026" },
    { name: "Glen Carbon", zips: "62034" },
    { name: "Granite City", zips: "62040" },
    { name: "Collinsville", zips: "62234" },
    { name: "Jerseyville", zips: "62052" },
    { name: "Grafton", zips: "62037" },
    { name: "St. Charles, MO", zips: "63301, 63303" },
    { name: "Florissant, MO", zips: "63031, 63033" },
    { name: "St. Louis, MO", zips: "63101, 63102, 63103" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 4.5 hours away but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for River Bend travelers" },
    { icon: "ri-anchor-line", title: "River Bend Coverage", desc: "Serving Alton, Godfrey, East Alton, Wood River, Bethalto, and the entire Meeting of the Great Rivers region" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from any UPS or FedEx in Alton — no 9-hour Chicago round trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Emergency passport help in Springfield, IL", route: "/cities/springfield-il" },
    { name: "Urgent passport services in Belleville, IL", route: "/cities/belleville" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Alton, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (4 hours 30 minutes northeast via I-55) — without you making the trip. Alton residents can ship from any UPS or FedEx in Madison County. For River Bend travelers, our courier service eliminates an entire day of driving to Chicago.",
  fpcOfficeDistance: "Serving Alton, Godfrey, East Alton, Wood River, Bethalto, Roxana, Edwardsville, Glen Carbon, Granite City, Collinsville, Jerseyville, Grafton, St. Charles MO, Florissant MO, St. Louis MO, and all of Madison County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Alton and the entire River Bend region. From the historic Alton riverfront and limestone bluffs to the growing communities of Godfrey and Edwardsville, from the industrial towns of Wood River and Roxana to the scenic Great River Road communities of Grafton and Jerseyville — we serve all of Madison County and the Illinois side of the St. Louis metropolitan area.",
  nearbyCitiesIntro: "We serve Alton and all nearby communities including Godfrey, East Alton, Wood River, Bethalto, Roxana, Edwardsville, Glen Carbon, Granite City, Collinsville, Jerseyville, and Grafton. We also serve St. Charles, Florissant, St. Louis, Missouri and the entire River Bend region.",
  howItWorksIntro: "Most Alton travelers complete everything online and ship documents overnight. No need to drive 4+ hours to Chicago — our couriers handle the Chicago Passport Agency trip for you. For River Bend residents, this is the practical fast solution that saves an all-day drive.",
  mistakesIntro: "Alton is a historic Mississippi River town with deep ties to the Meeting of the Great Rivers region, Lewis and Clark history, and easy access to St. Louis — yet the nearest passport agency is 4+ hours away. Here are the most common passport mistakes in the River Bend.",
  testimonialsIntro: "Alton travelers — from Lewis and Clark Community College students and Great River Road tourists to Madison County business professionals and European river cruise enthusiasts — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Alton, IL? Here are the most common ones we hear from River Bend travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "9+ hour round trip drive to Chicago", "Effectively impractical for most River Bend residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 9-hour round trip to Chicago required", "Perfect for last-minute river cruise departures", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Alton travelers with immediate departure needs — as fast as 24 hours. Essential for last-minute European river cruise departures and River Bend business travelers.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No 9-hour Chicago round trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Alton adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Alton address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Alton residents — including Lewis and Clark CC students, new citizens, and Madison County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Alton residents who lost their passport before international travel or a Mississippi River cruise.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Alton and Madison County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Alton and Madison County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Alton residents who need land/sea travel to Canada or Mexico — ideal for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Alton residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Alton business travelers and frequent international flyers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Alton IL", description: "Urgent passport processing for Alton Illinois travelers and River Bend residents with immediate departure needs." },
    { name: "Expedited Passport Renewal Alton IL", description: "Fast passport renewal for Alton Illinois residents and Madison County travelers." },
    { name: "First-Time Passport Alton IL", description: "New passport application services for Alton Illinois residents." },
    { name: "Child Passport Alton IL", description: "Minor passport services for Alton Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Karen W.",
      location: "Alton, IL",
      rating: 5,
      text: "Booked a Rhine River cruise leaving in 10 days and realized my passport expired during COVID. Fast Passport Center got me a new one in 4 days. Shipped from UPS on Homer Adams Parkway. Drove to St. Louis Lambert and flew to Amsterdam right on time. The river cruise was incredible — all thanks to this service!",
      service: "Passport Renewal",
    },
    {
      name: "Robert H.",
      location: "Godfrey, IL",
      rating: 5,
      text: "Business trip to Japan with 8 days notice. My passport was damaged — water got into my bag on the Great River Road. Fast Passport Center handled everything. Had my new passport in 3 days. Shipped from Godfrey and was in Tokyo by the weekend. Unbelievable speed for the River Bend area.",
      service: "Damaged Passport",
    },
    {
      name: "Michelle D.",
      location: "Alton, IL",
      rating: 5,
      text: "Son's study abroad to Spain was approved last minute at Lewis and Clark. Needed his first passport in 2 weeks. Fast Passport Center walked me through the DS-11 for minors and we had it in 5 days. He's now studying in Barcelona. Incredible service for River Bend families.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "aln-1",
      name: "Alton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "727 Belle St",
      city: "Alton",
      state: "IL",
      zip: "62002",
      phone: "(618) 462-6445",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Alton, Downtown near Broadway",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Alton acceptance facility. Convenient to downtown Alton and the historic district. Appointments strongly recommended. Near the Clark Bridge.",
      icon: "ri-mail-line",
    },
    {
      id: "aln-2",
      name: "Madison County Circuit Clerk — Edwardsville",
      type: "County Clerk Passport Acceptance",
      address: "155 N Main St",
      city: "Edwardsville",
      state: "IL",
      zip: "62025",
      phone: "(618) 692-6240",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Edwardsville, Madison County Courthouse, approximately 15 miles east of Alton",
      website: "https://www.madisoncountyil.gov/",
      websiteLabel: "Madison County Circuit Clerk",
      notes: "Madison County acceptance facility at the county seat in Edwardsville. SIUE campus nearby. Call ahead to confirm passport acceptance hours and availability.",
      icon: "ri-government-line",
    },
    {
      id: "aln-3",
      name: "Godfrey Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 Tolle Ln",
      city: "Godfrey",
      state: "IL",
      zip: "62035",
      phone: "(618) 466-2401",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Godfrey, approximately 5 miles north of Alton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Godfrey and northern Alton area residents. Serves the Lewis and Clark Community College area. Good alternative to Alton post office.",
      icon: "ri-mail-line",
    },
    {
      id: "aln-4",
      name: "Wood River Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "161 E Ferguson Ave",
      city: "Wood River",
      state: "IL",
      zip: "62095",
      phone: "(618) 254-4805",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wood River, approximately 7 miles southeast of Alton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wood River, East Alton, and Roxana. Convenient for southern Alton area residents near the refinery district.",
      icon: "ri-mail-line",
    },
    {
      id: "aln-5",
      name: "Collinsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "130 S Center St",
      city: "Collinsville",
      state: "IL",
      zip: "62234",
      phone: "(618) 344-1701",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Collinsville, approximately 20 miles southeast of Alton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Collinsville and Madison County. Near I-55/70 for easy access. Good option for travelers near the St. Clair County line.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Chicago", fpc: "No — ship from Alton" },
    { feature: "Time Commitment", agency: "9+ hour round trip — full day lost", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for River Bend", agency: "No — an entire day investment", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "River Cruise Passport Surprise",
      description: "Alton is minutes from the Mississippi River and the Great River Road — many residents book European river cruises without checking passport validity. Most European river cruises require 6 months of validity. A passport expiring in 4 months means you cannot board.",
    },
    {
      icon: "ri-road-map-line",
      title: "Unnecessary Chicago Drive",
      description: "Many River Bend travelers think they can 'just drive to Chicago' for an emergency appointment. At 4.5 hours each way plus downtown Chicago parking and wait times, this is a 9+ hour ordeal — a full day gone that most people cannot afford to lose.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule Forgotten",
      description: "Many Alton international travelers don't realize that numerous countries require 6 months of passport validity beyond the return date. A passport valid for 4 months is effectively expired for most European and Asian destinations.",
    },
    {
      icon: "ri-image-line",
      title: "River Bend Photo Standards",
      description: "Local photo services in Alton and Godfrey may not consistently meet federal passport photo standards. The lighting, background, and sizing requirements are very strict. Always use a verified passport photo service.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Alton and Godfrey acceptance facilities. Our document review catches this before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Cruise Line Requirements Confusion",
      description: "Inland river cruise passengers often don't realize that international river cruises — like the Rhine, Danube, or Douro — require a passport just like any other international travel. Domestic Mississippi River cruises do not. Don't confuse the two.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Alton or Madison County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on Homer Adams Parkway or Broadway." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with river cruise departures, L&C student travel, and River Bend business needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 4+ hours away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Alton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Alton, IL?", a: "Fast Passport Center offers emergency passport processing in Alton, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (4 hours 30 minutes northeast via I-55) — without you making the trip. For River Bend residents, this eliminates an entire day of driving." },
    { q: "Does Alton have a passport agency?", a: "No — Alton does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 4 hours 30 minutes northeast via I-55. St. Louis also has a passport agency approximately 30 minutes southwest across the Mississippi River. Fast Passport Center's courier service is the most practical fast option for the River Bend." },
    { q: "Do you serve Godfrey, East Alton, and Edwardsville?", a: "Yes — Fast Passport Center serves all of Madison County and the River Bend including Alton, Godfrey, East Alton, Wood River, Bethalto, Roxana, Edwardsville, Glen Carbon, Granite City, Collinsville, Jerseyville, and Grafton. We also serve St. Charles and Florissant, Missouri." },
    { q: "What airport do Alton travelers use for international flights?", a: "Most Alton travelers use St. Louis Lambert International Airport (STL) — approximately 25 minutes southwest via I-270. STL offers comprehensive domestic connections and international flights. Chicago O'Hare (ORD) is approximately 4 hours 30 minutes northeast, typically used only when STL doesn't have the route." },
    { q: "Can I use your service for a European river cruise departure?", a: "Absolutely. Fast Passport Center is ideal for European river cruise passengers departing from the River Bend region. Whether it's the Rhine, Danube, or Douro — if your departure is days away and your passport isn't ready, we can help. Many Alton residents are river cruise enthusiasts and we're experienced with these timelines." },
    { q: "Can I get my child's passport expedited in Alton?", a: "Yes. Fast Passport Center expedites child passports in Alton for minors under 16. Both parents must appear or submit notarized consent. We guide Madison County families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Alton?", a: "Walgreens on Homer Adams Parkway, CVS on College Avenue, and the UPS Store in Alton all offer passport photos. Lewis and Clark Community College may also provide photo services for students. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in the River Bend?", a: "Honestly — no. The Chicago Passport Agency is 4+ hours away and requires appointments booked weeks in advance for non-emergencies. The St. Louis Passport Agency is closer at 30 minutes but also requires appointments. For regular urgent travel in the River Bend, Fast Passport Center's courier service is the most practical 24–48 hour option. It's why we're so popular in the Alton area." },
  ],
  photoLocations: [
    { name: "Walgreens — Alton", address: "1 E Broadway, Alton, IL 62002", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Alton", address: "1837 Homer M Adams Pkwy, Alton, IL 62002", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Alton", address: "2704 College Ave, Alton, IL 62002", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walgreens — Wood River", address: "1100 Vaughn Rd, Wood River, IL 62095", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Alton", address: "501 Alton Sq, Alton, IL 62002", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located in Alton Square area. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Edwardsville", address: "1502 Troy Rd, Edwardsville, IL 62025", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Edwardsville, Glen Carbon, and eastern Madison County. REAL ID processing available. Near SIUE campus.", featured: false },
  ],
  airports: [
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "Approximately 25 minutes southwest of Alton via I-270",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Primary international airport for Alton and the River Bend. Southwest Airlines hub with domestic connections and international flights. The closest major airport — about 25 minutes from Alton.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 4 hours 30 minutes northeast via I-55",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Used when STL doesn't have the specific international route needed. About 4.5 hours from Alton — a full-day trip.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
};